import React from 'react'
import PropTypes from 'prop-types'
import { GridItemMain } from './index.style'
import { grid } from '../../styles/vars/grid.style'

const GridItem = ({
  as,
  children,
  colCount,
  tiny,
  mobile,
  mobileL,
  tabletP,
  tabletL,
  desk,
  deskM,
  deskL,
  contained,
  tinyStart,
  mobileStart,
  mobileLStart,
  tabletPStart,
  tabletLStart,
  deskStart,
  deskMStart,
  deskLStart,
  containedStart,
  tinyOrder,
  mobileOrder,
  mobileLOrder,
  tabletPOrder,
  tabletLOrder,
  deskOrder,
  deskMOrder,
  deskLOrder,
  containedOrder,
  tinyAlign,
  mobileAlign,
  mobileLAlign,
  tabletPAlign,
  tabletLAlign,
  deskAlign,
  deskMAlign,
  deskLAlign,
  containedAlign,
  tinyHeight,
  mobileHeight,
  mobileLHeight,
  tabletPHeight,
  tabletLHeight,
  deskHeight,
  deskMHeight,
  deskLHeight,
  containedHeight,
}) => (
  <GridItemMain
    as={as}
    colCount={colCount}
    tiny={tiny}
    mobile={mobile}
    mobileL={mobileL}
    tabletP={tabletP}
    tabletL={tabletL}
    desk={desk}
    deskM={deskM}
    deskL={deskL}
    contained={contained}
    tinyStart={tinyStart}
    mobileStart={mobileStart}
    mobileLStart={mobileLStart}
    tabletPStart={tabletPStart}
    tabletLStart={tabletLStart}
    deskStart={deskStart}
    deskMStart={deskMStart}
    deskLStart={deskLStart}
    containedStart={containedStart}
    tinyOrder={tinyOrder}
    mobileOrder={mobileOrder}
    mobileLOrder={mobileLOrder}
    tabletPOrder={tabletPOrder}
    tabletLOrder={tabletLOrder}
    deskOrder={deskOrder}
    deskMOrder={deskMOrder}
    deskLOrder={deskLOrder}
    containedOrder={containedOrder}
    tinyAlign={tinyAlign}
    mobileAlign={mobileAlign}
    mobileLAlign={mobileLAlign}
    tabletPAlign={tabletPAlign}
    tabletLAlign={tabletLAlign}
    deskAlign={deskAlign}
    deskMAlign={deskMAlign}
    deskLAlign={deskLAlign}
    containedAlign={containedAlign}
    tinyHeight={tinyHeight}
    mobileHeight={mobileHeight}
    mobileLHeight={mobileLHeight}
    tabletPHeight={tabletPHeight}
    tabletLHeight={tabletLHeight}
    deskHeight={deskHeight}
    deskMHeight={deskMHeight}
    deskLHeight={deskLHeight}
    containedHeight={containedHeight}
  >
    {children}
  </GridItemMain>
)

GridItem.propTypes = {
  children: PropTypes.node,
  colCount: PropTypes.number,
  tiny: PropTypes.number,
  mobile: PropTypes.number,
  mobileL: PropTypes.number,
  tabletP: PropTypes.number,
  tabletL: PropTypes.number,
  desk: PropTypes.number,
  deskM: PropTypes.number,
  deskL: PropTypes.number,
  contained: PropTypes.number,
  tinyStart: PropTypes.number,
  mobileStart: PropTypes.number,
  mobileLStart: PropTypes.number,
  tabletPStart: PropTypes.number,
  tabletLStart: PropTypes.number,
  deskStart: PropTypes.number,
  deskMStart: PropTypes.number,
  deskLStart: PropTypes.number,
  containedStart: PropTypes.number,
  tinyOrder: PropTypes.number,
  mobileOrder: PropTypes.number,
  mobileLOrder: PropTypes.number,
  tabletPOrder: PropTypes.number,
  tabletLOrder: PropTypes.number,
  deskOrder: PropTypes.number,
  deskMOrder: PropTypes.number,
  deskLOrder: PropTypes.number,
  containedOrder: PropTypes.number,
  tinyAlign: PropTypes.string,
  mobileAlign: PropTypes.string,
  mobileLAlign: PropTypes.string,
  tabletPAlign: PropTypes.string,
  tabletLAlign: PropTypes.string,
  deskAlign: PropTypes.string,
  deskMAlign: PropTypes.string,
  deskLAlign: PropTypes.string,
  containedAlign: PropTypes.string,
}

GridItem.defaultProps = {
  colCount: grid.colCount,
}

export default GridItem
